import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-mobauth',
  template: `
    <p>
      mobauth works!
    </p>
  `,
  styles: []
})
export class MobauthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
